export const BUDGET_NUMBER_PATTERN = /^\d+[\.,]?\d*$/;

export const formatBudgetInput = (raw: string) => {
  const cleaned = raw.replace(/\s/g, "").replace(",", ".");
  if (!cleaned.match(BUDGET_NUMBER_PATTERN)) {
    return raw;
  }
  const [integerPart, decimalPart] = cleaned.split(".");
  const grouped = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return decimalPart === undefined ? grouped : `${grouped},${decimalPart}`;
};
